import { useSelector, shallowEqual } from 'react-redux'


export enum DetailsGroup {
  NoGroup = 'no_group',
  ByAllowances = 'by_allowances',
  ByStudents = 'by_students',
  ByClasses = 'by_klasses',
  ByClassesAndOrders = 'by_klasses_and_orders',
  ByAllowancesAndFoodModes = 'by_allowances_and_food_modes'
}

const isDetailsGroup = (key: string): key is DetailsGroup => {
  return Object.values(DetailsGroup).includes(key as DetailsGroup)
}

export function useReportDetailsGroup() {
  const detailsGroup = useSelector((state: any) => state.reports.subsidies.data.details_group, shallowEqual)
  if (isDetailsGroup(detailsGroup)) return detailsGroup
  return null
}
